import { Component, Input } from '@angular/core'

import { RouterModule } from '@angular/router'

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
    @Input({ required: true })
    paths: BreadcrumbPath[]

    @Input ({required:true})
    isIris: boolean
}

export interface BreadcrumbPath {
    label: string
    lien?: string
}
